<template>
  <h2 class="content_title">{{ title }}</h2>
</template>

<script>
export default {
  props: ['title']
}
</script>

<style lang="css" scoped>
.content_title {
  background-color: #4FCCD4;
  border-radius: 0 100px 100px 0;
  color: #fff;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  padding: 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/GeneralTitle.vue